export default __webpack_public_path__ + "static/yamamoto-1f1ddd33888a32148557a1a88cfbd6e3.png";